import React, { Component, api } from "react";
import "./index.scss";
import { recordEven } from "@/api/actions";
export default class HospitalList extends Component {
  state = {
    hospitalList: [],
    selectHospital: null,
    isShowArea: false
  };
  componentDidMount() {
    api("HOSPITALLIST").then(res => {
      this.setState({
        hospitalList: res
      });
    });
  }
  render() {
    const { hospitalList, selectHospital, isShowArea } = this.state;
    return (
      <div
        className="toast_bg"
        onClick={() => {
          this.setState({
            isShowArea: false
          });
        }}
      >
        <div className="hospital_box  poa">
          <div className="hospital_top dis_f ali_ct jus_bt">
            <div className="top_txt">可提供HIV检测的医院名单</div>
            <img
              onClick={this.props.onCloseBtn}
              src={require("@img/close.png")}
              className="top_close"
            />
          </div>
          <div className="hospital_body" onClick={e => e.stopPropagation()}>
            <div className="select_area">
              <div
                className={`select_area_txt por dis_f ali_ct jus_bt ${
                  isShowArea ? "active" : ""
                }`}
                onClick={() => {
                  this.setState({
                    isShowArea: !isShowArea
                  });
                  recordEven("选择省份");
                }}
              >
                <p>{selectHospital ? selectHospital : "选择省份"}</p>
                <img src={require("@img/arrowdown.png")} />
              </div>
              {/* 省区列表 */}
              <div className={`select_box ${isShowArea ? "" : "dis_n"}`}>
                {hospitalList.map((item, num) => (
                  <div
                    key={num}
                    className="select_item"
                    onClick={() => {
                      this.setState({
                        selectHospital: item.province,
                        isShowArea: false
                      });
                      recordEven(item.province);
                    }}
                  >
                    {item.province}
                  </div>
                ))}
              </div>
            </div>
            <div className="hot_hospital">带*标医院含预防门诊</div>
            {/* 医院列表 */}
            <div className="hospital_list">
              <div className="hospital_list_top">医院列表</div>
              <div
                className={`hospital_result ${selectHospital ? "" : "dis_n"}`}
              >
                {selectHospital &&
                  hospitalList
                    .find(item => item.province == selectHospital)
                    .hospitalname.map((i, n) => (
                      <div
                        onClick={() => recordEven(i)}
                        className="hospital_item"
                        key={n}
                      >
                        {i}
                      </div>
                    ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
